// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2G2Um","cell":"ColumnAccessor_cell__3vsLZ","firstCellAccent":"ColumnAccessor_firstCellAccent__3_2uK"};